var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[
    'lbz-list',
    _vm.type && ("lbz-list--" + _vm.type),
    _vm.onBackground && ("lbz-list--on-" + _vm.onBackground),
    _vm.darkened && 'lbz-is-darkened',
    _vm.nav && 'lbz-is-nav',
    _vm.cisDense && 'lbz-is-dense'
  ]},[(_vm.subheader)?_c('span',{class:['lbz-list__subheader', _vm.align && ("lbz-list__subheader--" + _vm.align)],domProps:{"innerHTML":_vm._s(_vm.subheader)}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }